import {
  login,
  fetchActiveUser,
  checkId,
  updateUserFields,
  handleTwoFactor,
} from './auth.service';
import {
  LOGIN_START,
  LOGIN_SUCCESS,
  LOGIN_FAILED,
  FETCH_ACTIVE_USER_START,
  FETCH_ACTIVE_USER_SUCCESS,
  FETCH_ACTIVE_USER_FAILED,
  CHECK_ID_START,
  CHECK_ID_SUCCESS,
  CHECK_ID_FAILED,
  UPDATE_USER_FIELDS_START,
  UPDATE_USER_FIELDS_SUCCESS,
  UPDATE_USER_FIELDS_FAILED,
  HANDLE_TWO_FACTOR_START,
  HANDLE_TWO_FACTOR_SUCCESS,
  HANDLE_TWO_FACTOR_FAILED,
} from './auth.types';

//! PLOP_APPEND_ACTION

export function fetchActiveUserAction() {
  return async function _(dispatch) {
    const promise = fetchActiveUser(); // modify by your logic
    dispatch({
      type: [
        FETCH_ACTIVE_USER_START,
        FETCH_ACTIVE_USER_SUCCESS,
        FETCH_ACTIVE_USER_FAILED,
      ],
      payload: promise,
    });
    return promise;
  };
}

export function handleTwoFactorAction(data) {
  return async function _(dispatch) {
    const promise = handleTwoFactor(data); // modify by your logic
    dispatch({
      type: [
        HANDLE_TWO_FACTOR_START,
        HANDLE_TWO_FACTOR_SUCCESS,
        HANDLE_TWO_FACTOR_FAILED,
      ],
      payload: promise,
    });
    return promise;
  };
}

export function checkIdAction({ idNumber }) {
  return async function _(dispatch) {
    const promise = checkId({ idNumber }); // modify by your logic
    dispatch({
      type: [CHECK_ID_START, CHECK_ID_SUCCESS, CHECK_ID_FAILED],
      payload: promise,
    });
    return promise;
  };
}

export function updateUserFieldsAction(updatedFields) {
  return async function _(dispatch) {
    const promise = updateUserFields(updatedFields); // modify by your logic
    dispatch({
      type: [
        UPDATE_USER_FIELDS_START,
        UPDATE_USER_FIELDS_SUCCESS,
        UPDATE_USER_FIELDS_FAILED,
      ],
      payload: promise,
    });
    return promise;
  };
}

export function loginAction(credentials) {
  return async function _(dispatch) {
    const promise = login(credentials); // modify by your logic
    dispatch({
      type: [LOGIN_START, LOGIN_SUCCESS, LOGIN_FAILED],
      payload: promise,
    });
    return promise;
  };
}
